/**
 * @generated SignedSource<<cb2bf5beed612ec4e499de601361ff00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueBodyHeaderAuthor$data = {
  readonly avatarUrl: string;
  readonly login: string;
  readonly " $fragmentType": "IssueBodyHeaderAuthor";
};
export type IssueBodyHeaderAuthor$key = {
  readonly " $data"?: IssueBodyHeaderAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueBodyHeaderAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueBodyHeaderAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "bf10a4271ec6ac2d490741da786252be";

export default node;
